import Edit from "@mui/icons-material/Edit";
import type { BoxProps } from "@mui/material";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import type { FC } from "react";
import { useSearchParams } from "react-router";

export const PromptSummary: FC<{ onClick: () => void } & BoxProps> = ({
  onClick,
  sx = [],
  ...props
}) => {
  const [searchParams] = useSearchParams();

  const answer = searchParams.get("answer");
  const format = searchParams.get("format");

  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("sm"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box
      className="PromptSummary-root"
      sx={[
        {
          display: "flex",
          flexDirection: "row",
          gap: 1,
          py: 1,
          px: 5,
          background:
            theme.palette.mode === "light"
              ? `linear-gradient(90deg, #f4e8f5 0%, #eaeef9 40%, #e6f6f7 100%)`
              : `linear-gradient(90deg, #0b1222 0%, #0e1a2f 25%, #0b2035 75%, #07252f 100%)`,
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            pr: 3,
          },
        },
        ...(sx instanceof Array ? sx : [sx]),
      ]}
      {...props}
    >
      <Typography variant="body1" noWrap flexShrink={0} data-testid="prompt-format">
        {format}
      </Typography>
      <Typography variant="body1">•</Typography>
      <Typography
        variant="body1"
        flexGrow={1}
        textOverflow="ellipsis"
        noWrap
        data-testid="prompt-answer"
      >
        {answer}
      </Typography>

      {sm && (
        <Button
          data-analytics-id="create-content-edit-prompt"
          size="small"
          variant="outlined"
          onClick={onClick}
          sx={{ textWrap: "nowrap", minWidth: "8em" }}
        >
          Edit Prompt
        </Button>
      )}
      {xs && (
        <Tooltip title="Edit Prompt">
          <IconButton
            data-analytics-id="create-content-edit-prompt"
            size="small"
            onClick={onClick}
            color="primary"
          >
            <Edit />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
